import Marquee from "react-fast-marquee";
import { Sun } from "lucide-react";
import CAMPAIGN from "@/data/campaign";

const MarqueeBand = () => (
  <section className="bg-secondary border-y border-border py-8 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={30} gradient={false} pauseOnHover>
      {CAMPAIGN.marquee.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-heading italic font-light text-2xl md:text-4xl text-foreground/80 px-10 whitespace-nowrap">
            {item}
          </span>
          <Sun className="w-5 h-5 text-primary shrink-0" />
        </span>
      ))}
    </Marquee>
  </section>
);

export default MarqueeBand;
